import { tss } from "tss-react/mui";

export const useCategoriesSectionStyles = tss.withName("CategoriesSection").create(({ theme }) => ({
    header: {
        maxWidth: 640,
        marginBottom: theme.spacing(6),
    },
    description: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(2),
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridAutoRows: "minmax(220px, auto)",
        gap: theme.spacing(2),
        "& > *:nth-of-type(1)": {
            gridColumn: "span 2",
            gridRow: "span 2",
        },
        "& > *:nth-of-type(2)": {
            gridColumn: "span 2",
        },
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(2, 1fr)",
            "& > *:nth-of-type(1)": {
                gridColumn: "span 1",
                gridRow: "span 1",
            },
            "& > *:nth-of-type(2)": {
                gridColumn: "span 1",
            },
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    card: {
        position: "relative" as const,
        display: "block",
        overflow: "hidden",
        height: "100%",
        minHeight: 220,
        textDecoration: "none",
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
        transition: "transform 0.6s ease",
    },
    overlay: {
        position: "absolute" as const,
        inset: 0,
        background: "linear-gradient(180deg, rgba(24,18,13,0) 40%, rgba(24,18,13,0.7) 100%)",
    },
    cardContent: {
        position: "absolute" as const,
        left: theme.spacing(3),
        right: theme.spacing(3),
        bottom: theme.spacing(3),
        color: theme.palette.common.white,
    },
    cardTitle: {
        color: theme.palette.common.white,
        marginBottom: theme.spacing(0.5),
    },
    cardDescription: {
        color: "rgba(255,255,255,0.85)",
        marginBottom: theme.spacing(1.5),
    },
}));
